
<template>
    <div class="experiments-container" aria-label="Experiments">
        <div class="experiment-grid">
            <div class="experiment-grid__cell"
                v-for="(experimentData, experimentIndex) in contentData.items"
                :key="experimentIndex">
                <experiment-item :item-data="experimentData">
                </experiment-item>
            </div>
        </div>
    </div>
</template>

<script>
import experimentItem from '@/components/ExperimentItem.vue';

export default {
    props: {
        contentData: Object,
    },
    components: {
        experimentItem,
    },
};
</script>

<style lang="scss">
    .experiment-grid {
        display: flex;
        flex-wrap: wrap;
        margin-top: -2rem;

        @include mq($from: md) {
            margin-top: -4rem;
        }

        @include mq($from: ml) {
            width: calc(100% + 5rem);
            margin-top: -5rem;
        }
    }

    .experiment-grid__cell {
        display: flex;
        width: 100%;
        margin: 2rem 0 0 0;

        @include mq($from: md) {
            margin: 4rem 0 0 0;
        }

        // 2 per row, 5rem gutter
        @include mq($from: ml) {
            width: calc(50% - 5rem);
            margin: 5rem 5rem 0 0;
        }
    }
</style>
